export class ControleEstoqueDetalheMovimentosRequest {
  searchText?: string;
  idLocalizacaoEstoque?: number | null;
  idTipoMovimentoFiltro: number = 0;
  dataInicial?: string | null;
  dataFinal?: string | null;
}
